<template>
  <div class="timeline-container">
    <ul>
      <li
        :class="[
          itemStatus.isSolicitationApproved || itemStatus.isSolicitationRefused
            ? 'is-orange-after'
            : 'is-grey-after'
        ]"
      >
        <div class="circle is-orange"></div>
        <h5>Em Análise</h5>
      </li>
      <li :class="[isItemNotRefused() ? 'is-orange-after' : 'is-grey-after']">
        <h5
          v-show="
            itemStatus.isSolicitationApproved ||
              itemStatus.isSolicitationRefused
          "
        >
          Solicitação {{ solicitationStatus }}
        </h5>
        <div
          class="circle"
          :class="[
            itemStatus.isSolicitationApproved ||
            itemStatus.isSolicitationRefused
              ? 'is-orange'
              : 'is-grey'
          ]"
        ></div>
      </li>
      <li
        :class="[
          itemStatus.isInverseOrderApproved || itemStatus.isInverseOrderRefused
            ? 'is-orange-after'
            : 'is-grey-after'
        ]"
      >
        <h5 v-show="isItemNotRefused()">Aguardando Criação OI</h5>
        <div
          class="circle"
          :class="[isItemNotRefused() ? 'is-orange' : 'is-grey']"
        ></div>
      </li>
      <li
        :class="[
          isInvereseOrderNotRefused() ? 'is-orange-after' : 'is-grey-after'
        ]"
      >
        <h5
          v-show="
            itemStatus.isInverseOrderApproved ||
              itemStatus.isInverseOrderRefused
          "
        >
          {{ oiStatus }}
        </h5>
        <div
          class="circle"
          :class="[
            itemStatus.isInverseOrderApproved ||
            itemStatus.isInverseOrderRefused
              ? 'is-orange'
              : 'is-grey'
          ]"
        ></div>
      </li>
      <li
        :class="[
          itemStatus.isCollectionScheduled ? 'is-orange-after' : 'is-grey-after'
        ]"
      >
        <h5 v-show="isInvereseOrderNotRefused()">Agendamento de Coleta</h5>
        <div
          class="circle"
          :class="[isInvereseOrderNotRefused() ? 'is-orange' : 'is-grey']"
        ></div>
      </li>
      <li
        :class="[
          itemStatus.isCollectionScheduled && itemStatus.isInTransit
            ? 'is-orange-after'
            : 'is-grey-after'
        ]"
      >
        <h5 v-show="itemStatus.isCollectionScheduled">
          Aguardando Faturamento
        </h5>
        <div
          class="circle"
          :class="[itemStatus.isCollectionScheduled ? 'is-orange' : 'is-grey']"
        ></div>
      </li>
      <li
        :class="[
          itemStatus.isReturnRefused && itemStatus.isInTransit
            ? 'is-orange-after'
            : 'is-grey-after'
        ]"
      >
        <h5 v-show="itemStatus.isCollectionScheduled && itemStatus.isInTransit">
          Em Trânsito
        </h5>
        <div
          class="circle"
          :class="[
            itemStatus.isCollectionScheduled && itemStatus.isInTransit
              ? 'is-orange'
              : 'is-grey'
          ]"
        ></div>
      </li>
      <li
        :class="[
          itemStatus.isReturnRefused ? 'is-orange-after' : 'is-grey-after'
        ]"
      >
        <h5 v-show="itemStatus.isReturnRefused">{{ finalStatus }}</h5>
        <div
          class="circle"
          :class="[itemStatus.isReturnRefused ? 'is-orange' : 'is-grey']"
        ></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Timeline",
  props: ["status"],
  data() {
    return {
      solicitationStatus: "Aprovada",
      itemStatus: {
        isSolicitationApproved: false,
        isSolicitationRefused: false,
        isInverseOrderApproved: false,
        isInverseOrderRefused: false,
        isCollectionScheduled: false,
        isReturnRefused: false,
        isInTransit: false
      },
      finalStatus: "",
      oiStatus: "OI Aprovada"
    };
  },
  methods: {
    isItemNotRefused() {
      return (
        this.itemStatus.isSolicitationApproved && this.finalStatus != "Recusado"
      );
    },
    isInvereseOrderNotRefused() {
      return (
        this.itemStatus.isInverseOrderApproved && this.oiStatus != "OI Recusada"
      );
    }
  },
  created() {
    switch (this.status) {
      case "Recusada":
      case "Faturada":
      case "Faturada Parcial":
        this.itemStatus.isReturnRefused = true;
      case "Em Trânsito":
        this.itemStatus.isInTransit = true;
      case "Aguardando Faturamento":
        this.itemStatus.isCollectionScheduled = true;
      case "Aguardando data de coleta":
      case "Aguardando Data de Coleta":
        this.itemStatus.isInverseOrderApproved = true;
      case "OI Recusada":
        this.itemStatus.isInverseOrderRefused = true;
      case "Aguardando Criação de OI":
        this.itemStatus.isSolicitationApproved = true;
      case "Solicitação Reprovada":
        this.itemStatus.isSolicitationRefused = true;
        break;
    }
    if (
      this.status == "Recusada" ||
      this.status == "Faturada" ||
      this.status == "Faturada Parcial"
    ) {
      this.finalStatus = this.status;
    }
    if (this.status == "OI Recusada") {
      this.oiStatus = "OI Recusada";
    }
    if (this.status == "Solicitação Reprovada") {
      this.solicitationStatus = "Reprovada";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";

.timeline-container {
  position: relative;
  height: 110px;
  width: 100%;
  min-width: 550px;
  align-self: center;
  padding: 10px 10px 50px 10px;

  ul {
    display: flex;
    list-style: none;
    padding: 0;

    li {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 12.5%;
      text-align: center;
      color: $grey1;

      h5 {
        margin: 10px;
      }

      .circle {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        position: absolute;
        top: 45px;
        margin-top: 10px;
        z-index: 1;
      }
    }

    li:after {
      content: "";
      width: 100%;
      position: absolute;
      top: 71px;
      height: 3px;
      background: $grey2;
      right: 45%;
    }

    li:first-child:after {
      content: none;
    }
  }
}

.is-grey {
  background: $grey5;
}

.is-text-orange {
  color: $orange1;
}

.is-orange {
  background: $orange1;
}

.is-oranges:after {
  background: $orange1;
}

li.is-orange-after + li:after {
  background: $orange1;
}

li.is-grey-after + li:after {
  background: $grey5;
}

@media (max-width: 1700px) {
  h5 {
    font-size: 11px;
  }
}
</style>
